import { FaFacebookF } from "react-icons/fa";
import { FiInstagram, FiYoutube } from "react-icons/fi";
import "../css/component.css";
const SidePanel = () => {
  return (
    <div className="sidePanel">
      <a href="https://www.facebook.com/memo.ry.1088" className="link">
        <FaFacebookF className="icons" />
      </a>
      <a href="https://www.instagram.com/_e_j_n/" className="link">
        <FiInstagram className="icons" />
      </a>
      <a
        href="https://www.youtube.com/channel/UCf2zK3AHKRy8gGThBF3tpxg"
        className="link"
      >
        <FiYoutube className="icons" />
      </a>
      <span className="connect">connect with me</span>
    </div>
  );
};

export default SidePanel;
